/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { AnyAction, SerializedError } from '@reduxjs/toolkit';

import * as actionType from './actionTypes';

//---- GET ALL INTENT CONFLICTS

export const getAllIntentConflicts = (
  workspaceId: string,
  skillId: string,
  useNewIAUpdatedAccess: boolean,
  assistantId: string
): AnyAction => ({
  type: actionType.FETCH_ALL_INTENT_CONFLICTS,
  workspaceId,
  skillId,
  useNewIAUpdatedAccess,
  assistantId
});

export const getAllIntentConflictsSuccess = (
  allIntentConflicts: object
): AnyAction => ({
  type: actionType.FETCH_ALL_INTENT_CONFLICTS_SUCCESS,
  allIntentConflicts
});

export const getAllIntentConflictsError = (
  error: SerializedError
): AnyAction => ({
  type: actionType.FETCH_ALL_INTENT_CONFLICTS_ERROR,
  error
});

//---- GET CONFLICTS FOR A SPECIFIC INTENT

export const getConflictsForSingleIntent = (
  workspaceId: string,
  intentName: string,
  skillId: string,
  useNewIAUpdatedAccess: boolean,
  assistantId: string
): AnyAction => ({
  type: actionType.FETCH_SINGLE_INTENT_CONFLICTS,
  workspaceId,
  intentName,
  skillId,
  useNewIAUpdatedAccess,
  assistantId
});

export const getConflictsForSingleIntentSuccess = (
  conflictsForIntent: object
): AnyAction => ({
  type: actionType.FETCH_SINGLE_INTENT_CONFLICTS_SUCCESS,
  conflictsForIntent
});

export const getConflictsForSingleIntentError = (
  error: SerializedError
): AnyAction => ({
  type: actionType.FETCH_SINGLE_INTENT_CONFLICTS_ERROR,
  error
});

//---- GET CONFLICTS FOR A SPECIFIC EXAMPLE

export const getConflictsForIntentExample = (
  workspaceId: string,
  intentName: string,
  exampleId: string,
  skillId: string,
  useNewIAUpdatedAccess: boolean,
  assistantId: string
): AnyAction => ({
  type: actionType.FETCH_INTENT_EXAMPLE_CONFLICTS,
  workspaceId,
  intentName,
  exampleId,
  skillId,
  useNewIAUpdatedAccess,
  assistantId
});

export const getConflictsForIntentExampleSuccess = (
  conflictsForIntentExample: object
): AnyAction => ({
  type: actionType.FETCH_INTENT_EXAMPLE_CONFLICTS_SUCCESS,
  conflictsForIntentExample
});

export const getConflictsForIntentExampleError = (
  error: SerializedError
): AnyAction => ({
  type: actionType.FETCH_INTENT_EXAMPLE_CONFLICTS_ERROR,
  error
});
